import { cornerType, granularity } from '../mixinProps'

/**
 * vc-graphics-polyline-volume base props mixins
 */
export default {
  mixins: [cornerType, granularity]
}
